import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { doorDashApi } from 'api/doorDash';
import { goPuffApi } from 'api/goPuff';
import { UserContext } from 'contexts/UserContext';
import { DataTable, Notifications, WholesaleAccountPicker } from 'shared';
import dayjs from 'utils/dayjsConfig';

function ViewGoPuffPricing() {
    const [rows, setRows] = useState([]);
    const [notification, setNotification] = useState({ text: null, level: null });
    const { wholesaleAccount } = useContext(UserContext);
    const [api, setApi] = useState(wholesaleAccount.fbmAccountName === 'doordash' ? doorDashApi : goPuffApi);

    // Load  table
    const getRows = async () => {
        const response = await api.getPricing();
        if (response.status === false) {
            setNotification({ text: `No entries found ${response.msg}`, level: 'error' });
            setRows([]);
            return;
        }

        const rows = (response.data?.rows ?? []).map((row) => ({
            ...row,
            createdAt: dayjs(row.createdAt.date).format('MM/DD/YYYY'),
            effectiveDate: dayjs(row.effectiveDate.date).format('MM/DD/YYYY'),
        }));

        setRows(rows);
    };

    useEffect(() => {
        if (wholesaleAccount.fbmAccountName === 'doordash') {
            setApi(doorDashApi);
        } else {
            setApi(goPuffApi);
        }
    }, [wholesaleAccount]);

    useEffect(() => {
        if (wholesaleAccount.id) {
            getRows();
        }
    }, [api]);

    const columns = [
        { Header: 'Pricing ID', accessor: 'id' },
        { Header: 'External SKU', accessor: 'externalSku' },
        { Header: 'Effective Date', accessor: 'effectiveDate' },
        { Header: 'Each Cost', accessor: 'eachCost' },
        { Header: 'Case Cost', accessor: 'caseCost' },
        { Header: 'Currency', accessor: 'currency' },
        { Header: 'Facility', accessor: 'facilityID' },
    ];

    return (
        <div>
            <WholesaleAccountPicker />
            {!!wholesaleAccount.id && (
                <>
                    <h1>{wholesaleAccount.companyName} Pricing</h1>
                    <Link to="/gopuff/pricing-upload">Upload</Link>
                    <Notifications options={notification} />
                    {}
                    <div>
                        <DataTable columns={columns} data={rows} />
                    </div>
                </>
            )}
        </div>
    );
}

export { ViewGoPuffPricing };
